<template>
  <div class="content" id="messageLeft">
    <ul class="message-top">
      <li :class="{'active':change[0].show}" @click="changeType(0)">全部(36条)</li>
      <li :class="{'active':change[1].show}" @click="changeType(1)">待处理(3条)</li>
      <li :class="{'active':change[2].show}" @click="changeType(2)">未处理完(1条)</li>
      <li :class="{'active':change[3].show}" @click="changeType(3)">已处理(32条)</li>
      <button>添加留言</button>
    </ul>
    <ul>
      <li class="message-content">
        <div class="hint">
          <img src="@/assets/img/icon/u1488.png" alt>
          <span>吧台提醒你，请回复该信息</span>
        </div>
        <ul class="pack-up">
          <li>
            <span style="color:rgb(72, 87, 202);">网鱼网咖 - 花无缺(客户机A001)</span>&nbsp;
            <span style="font-weight:bold;">说:</span>&nbsp;
            <span>我要玩APEX啊，你们这游戏怎么还没更新！</span>
          </li>
          <li style="color:rgb(168, 168, 168);font-size:12px;">
            <span style="font-weight:bold;">吧台</span>&nbsp;
            <span style="font-weight:bold;">说:</span>&nbsp;
            <span>您好，我已经给你去搬救兵了！</span>
          </li>
          <li style="color:rgb(168, 168, 168);font-size:12px;">
            <span>
              <img src="@/assets/img/icon/u110.png" alt style="float:left;margin-right:10px;">
            </span>
            <span>12-12 23:23</span>
          </li>
        </ul>
      </li>
      <li class="message-content">
        <ul v-if="showContent" class="pack-up">
          <li>
            <span style="color:rgb(72, 87, 202);">网鱼网咖 - 花无缺(客户机A001)</span>&nbsp;
            <span style="font-weight:bold;">说:</span>&nbsp;
            <span>我要玩APEX啊，你们这游戏怎么还没更新！</span>
          </li>
          <li style="color:rgb(168, 168, 168);font-size:12px;">
            <span style="font-weight:bold;">吧台</span>&nbsp;
            <span style="font-weight:bold;">说:</span>&nbsp;
            <span>您好，我已经给你去搬救兵了！</span>
          </li>
          <li style="color:rgb(168, 168, 168);font-size:12px;">
            <span>
              <img src="@/assets/img/icon/u110.png" alt style="float:left;margin-right:10px;">
            </span>
            <span>12-12 23:23</span>
          </li>
        </ul>
        <ul v-if="!showContent" class="pack-up">
          <li>
            <div style="float:left;margin-right:10px;">
              <img src="@/assets/img/icon/u132.png" alt>
            </div>
            <div style="float:left;width:80%;">
              <p>
                <span class="user-color">网鱼网咖 - 花无缺(客户机A001)</span>&nbsp;
                <span style="font-weight:bold;">说:</span>&nbsp;
                <span>我要玩APEX啊，你们这游戏怎么还没更新！</span>
              </p>
              <p style="color:rgb(168, 168, 168);font-size:12px;">
                <span>
                  <img src="@/assets/img/icon/u110.png" alt style="float:left;margin-right:10px;">
                </span>
                <span>12-12 23:23</span>
              </p>
            </div>
          </li>
          <li>
            <div style="float:left;margin-right:10px;">
              <img src="@/assets/img/icon/u126.png" alt>
            </div>
            <div style="float:left;">
              <p>
                <span class="user-color">维护总监</span>&nbsp;
                <span style="font-weight:bold;">说:</span>&nbsp;
                <span>你好，游戏正在下载</span>
              </p>
              <p style="color:rgb(168, 168, 168);font-size:12px;">
                <span>
                  <img src="@/assets/img/icon/u110.png" alt style="float:left;margin-right:10px;">
                </span>
                <span>12-12 23:23</span>
              </p>
            </div>
          </li>
          <li>
            <div style="float:left;margin-right:10px;">
              <img src="@/assets/img/icon/u132.png" alt>
            </div>
            <div style="float:left;">
              <p>
                <span class="user-color">网鱼网咖 - 花无缺(客户机A001)</span>&nbsp;
                <span style="font-weight:bold;">说:</span>&nbsp;
                <span>好，谢谢</span>
              </p>
              <p style="color:rgb(168, 168, 168);font-size:12px;">
                <span>
                  <img src="@/assets/img/icon/u110.png" alt style="float:left;margin-right:10px;">
                </span>
                <span>12-12 23:23</span>
              </p>
            </div>
          </li>
          <div class="bottom">
            <input type="text" placeholder="请填写回复内容" v-model="content">
            <div class="bottom-face">
              <!-- <img src="@/assets/img/icon/u192.png" alt> -->
              <span>表情</span>
              <!-- <face></face> -->
            </div>
            <div class="bottom-face">
              <!-- <img src="@/assets/img/icon/u632.png" alt> -->
              <span>提醒吧台</span>
            </div>
            <div class="bottom-face">
              <!-- <img src="@/assets/img/icon/u634.png" alt> -->
              <span>设置为未处理完</span>
            </div>
            <button>发送</button>
          </div>
        </ul>
        <div class="reply" :class="{'reply-on':showContent}" @click="showContent = !showContent">
          <span v-if="!showContent">收起</span>
          <span v-if="showContent">回复</span>
          <span>
            <img src="@/assets/img/icon/u186.png" alt :class="{'rotate':showContent}">
          </span>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
// import face from "../face"
export default {
  components:{
    // face
  },
  data() {
    return {
      showContent: false,
      content: "",
      change: [
        { show: false },
        { show: false },
        { show: false },
        { show: false }
      ],
    };
  },
  methods: {
    changeType(type) {
      for (let i = 0; i < this.change.length; i++) {
        this.change[i].show = false;
      }
      this.change[type].show = true;
    },
  },
  mounted() {
    this.changeType(0);
  },
};
</script>
<style lang="scss" scoped>

.content {
  width:600px;
  margin:10px 20px;
  float:left;
}
.message-top {
  width: 100%;
  height: 40px;
  background-color: rgb(245, 245, 246);
  li {
    float: left;
    margin-left: 15px;
    line-height: 39px;
    cursor: pointer;
    transition: color 0.3s;
  }
  li:hover {
    color: rgb(70, 179, 216);
  }
  .active {
    border-bottom: 1.5px solid rgb(0, 153, 204);
    color: rgb(4, 144, 190);
  }
  button {
    float: right;
    margin: 5px;
    padding: 5px 10px;
    border: 1px solid rgb(230, 230, 230);
    background-color: #fff;
  }
}
.message-content {
  position: relative;
  margin-top: 10px;
  padding-bottom: 10px;
  width: 100%;
  border: 1px solid rgb(230, 230, 230);
  background-color: rgb(251, 252, 252);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.2);
  text-align: left;
  font-size: 14px;
  transition: all 0.3s;
  overflow: hidden;
  li {
    padding-left: 20px;
    padding-top: 10px;
  }
  .hint {
    float: left;
    display: flex;
    justify-content: center;
    padding: 0;
    width: 100%;
    height: 30px;
    line-height: 30px;
    background-color: rgb(252, 248, 226);
    border: 1px solid rgb(251, 236, 203);
    color: rgb(246, 131, 0);
    font-size: 12px;
    img {
      margin: 7px;
      width: 14px;
      height: 14px;
    }
  }
  .head-portrait {
    float: left;
  }
  .pack-up {
    float: left;
    li {
      overflow: hidden;
    }
    p {
      margin-bottom: 8px;
    }
  }
  .bottom {
    float: left;
    width: 570px;
    padding: 15px;
    input {
      width: 560px;
      height: 40px;
      float: left;
      padding-left: 10px;
      background-color: rgb(245, 245, 246);
      border-radius: 5px;
    }
    .bottom-face {
      float: left;
      margin: 15px 10px 0px 10px;
      line-height: 20px;
      color: rgb(0, 153, 204);
      cursor: pointer;
      img {
        float: left;
        margin-right: 5px;
      }
    }
    button {
      float: right;
      margin-top: 10px;
      margin-right: 10px;
      width: 100px;
      height: 30px;
      color: #fff;
      background-color: rgb(0, 153, 204);
      cursor: pointer;
      transition: background-color .3s;
    }
    button:hover {
      background-color: rgba(0, 153, 204,.8);
    }
  }
}
.message-content:hover {
  border: 1px solid rgb(0, 204, 255);
}
.reply {
  position: absolute;
  top: 10px;
  right: 5px;
  font-size: 12px;
  color: rgb(161, 161, 161);
  transition: all 0.3s;
  span {
    margin-right: 5px;
    cursor: pointer;
  }
  span:hover {
    color: rgb(0, 153, 204);
  }
}
.reply-on {
  top: 65px;
}
.rotate {
  transform: rotate(180deg);
}
.user-color {
  color: rgb(72, 87, 202);
  font-weight: bold;
}
</style>
